import { render, staticRenderFns } from "./AboutAcc.vue?vue&type=template&id=54c095a5"
import script from "./AboutAcc.vue?vue&type=script&lang=js"
export * from "./AboutAcc.vue?vue&type=script&lang=js"
import style0 from "./AboutAcc.vue?vue&type=style&index=0&id=54c095a5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports